"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PLUGINS = void 0;
var browser_plugin_button_click_tracking_1 = require("@snowplow/browser-plugin-button-click-tracking");
var browser_plugin_client_hints_1 = require("@snowplow/browser-plugin-client-hints");
var browser_plugin_enhanced_consent_1 = require("@snowplow/browser-plugin-enhanced-consent");
var browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
var browser_plugin_ga_cookies_1 = require("@snowplow/browser-plugin-ga-cookies");
var browser_plugin_site_tracking_1 = require("@snowplow/browser-plugin-site-tracking");
var browser_plugin_web_vitals_1 = require("@snowplow/browser-plugin-web-vitals");
var browser_plugin_media_1 = require("@snowplow/browser-plugin-media");
var customEnableConfigurations_1 = require("./customEnableConfigurations");
/**
 * Map of the Default Plugins for the Snowplow Web Tracker
 * These will be included in the tracker unless disabled by the user
 */
exports.DEFAULT_PLUGINS = {
  activityTracking: {
    enabled: true,
    enablePlugin: customEnableConfigurations_1.enableActivityTrackingWithConfig
  },
  buttonClickTracking: {
    enabled: true,
    plugin: browser_plugin_button_click_tracking_1.ButtonClickTrackingPlugin,
    enablePlugin: browser_plugin_button_click_tracking_1.enableButtonClickTracking
  },
  clientHints: {
    enabled: true,
    plugin: browser_plugin_client_hints_1.ClientHintsPlugin
  },
  enhancedConsent: {
    enabled: true,
    plugin: browser_plugin_enhanced_consent_1.EnhancedConsentPlugin
  },
  gaCookies: {
    enabled: true,
    plugin: browser_plugin_ga_cookies_1.GaCookiesPlugin
  },
  linkClickTracking: {
    enabled: true,
    plugin: browser_plugin_link_click_tracking_1.LinkClickTrackingPlugin,
    enablePlugin: browser_plugin_link_click_tracking_1.enableLinkClickTracking
  },
  siteTracking: {
    enabled: true,
    plugin: browser_plugin_site_tracking_1.SiteTrackingPlugin
  },
  webVitals: {
    enabled: true,
    plugin: browser_plugin_web_vitals_1.WebVitalsPlugin
  },
  mediaTracking: {
    enabled: true,
    plugin: browser_plugin_media_1.SnowplowMediaPlugin
  }
};